/*!
 * Yoda.js v0.5.0
 * (c) 2021-present By Kuaishou
 * Released under the ISC License.
 */
var _readyResolve;

var _readyPromise = new Promise(function (resolve) {
  _readyResolve = resolve;
});

function ready(callback) {
  if (callback) {
    _readyPromise.then(callback);
  }

  return _readyPromise;
}

/**
 * 注册 api
 * @param {object} obj
 *              namespace      命名空间
 *              name    api名
 *              before  format 请求参数
 *              after   format 返回值
 */
function register(config) {
  var _this = this;

  if (!(config && config.namespace && config.name)) {
    throw new Error('register 参数： {namespace, name}');
  }

  var namespace = this[config.namespace];

  if (!namespace) {
    namespace = this[config.namespace] = {};
  } // 可能是以下几种情况： (), (params), (params, option), (params, callback), (params, option, callback)


  namespace[config.name] = function (params, option, callback) {
    params = params || {};

    if (!callback && typeof option === 'function') {
      callback = option;
      option = null;
    }

    option = option || {};

    callback = callback || function () {};

    if (config.before) {
      // before可能会报错 直接抛出异常
      params = config.before(params);
    }

    var callbackId = _this.genCallbackId();

    var returnPromise;
    var invokeCallback;

    if (config.multiCallback || option.multiCallback) {
      invokeCallback = callback;
    } else {
      returnPromise = new Promise(function (resolve) {
        return invokeCallback = resolve;
      });
      returnPromise.then(function () {
        delete _this._callbacks[callbackId];
      });
      returnPromise.then(callback);
    }

    if (config.after) {
      var originInvokeCallback_1 = invokeCallback;

      invokeCallback = function invokeCallback(ret) {
        return originInvokeCallback_1(config.after(ret));
      };
    }

    _this._callbacks[callbackId] = invokeCallback;

    try {
      _this.invoke({
        namespace: config.namespace,
        name: config.name,
        params: params,
        callbackId: callbackId
      });
    } catch (e) {
      invokeCallback({
        // 桥调用异常
        result: 125014,
        message: e.message
      });
    }

    return returnPromise;
  };
}

/**
 *
 * @param {string} namespace
 * @param {string} name 接口名
 * @param {object} params 参数
 * @param {function} callback 回调函数
 */
function invoke(_a) {
  var namespace = _a.namespace,
      name = _a.name,
      params = _a.params,
      callbackId = _a.callbackId; // callbackId 约定为string

  window.__yodaBridge__.invoke(namespace, name, JSON.stringify(params), '' + callbackId);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var baseApis = [{
  namespace: 'system',
  name: 'getDeviceInfo'
}, {
  namespace: 'system',
  name: 'getAppInfo'
}, {
  namespace: 'system',
  name: 'getNetworkType'
}, {
  namespace: 'webview',
  name: 'open'
}, {
  namespace: 'webview',
  name: 'getLaunchParams'
}, {
  namespace: 'webview',
  name: 'close'
}, {
  namespace: 'webview',
  name: 'backOrClose'
}, {
  namespace: 'tool',
  name: 'canIUse'
}, {
  namespace: 'tool',
  name: 'checkAppInstalled'
}, {
  namespace: 'tool',
  name: 'launchApp'
}, {
  namespace: 'ui',
  name: 'setTopBarStyle'
}, {
  namespace: 'ui',
  name: 'setTitle'
}, {
  namespace: 'ui',
  name: 'setTopBarButton'
}, {
  namespace: 'ui',
  name: 'removeTopBarButton'
}, {
  namespace: 'ui',
  name: 'setSlideBackBehavior'
}, {
  namespace: 'ui',
  name: 'setPhysicalBackButtonBehavior'
}, {
  namespace: 'ui',
  name: 'showLoading'
}, {
  namespace: 'ui',
  name: 'hideLoading'
}, {
  namespace: 'ui',
  name: 'showToast'
}, {
  namespace: 'ui',
  name: 'showDialog'
}, {
  namespace: 'event',
  name: 'addEventListener'
}, {
  namespace: 'event',
  name: 'removeEventListener'
}, {
  namespace: 'event',
  name: 'dispatchEvent'
}];
var isAndroid = navigator.userAgent.indexOf(' Android ') > -1;
var overWriteApis = {
  'tool.checkAppInstalled': {
    before: function before(params) {
      return {
        identifier: params[isAndroid ? 'android' : 'ios']
      };
    }
  }
};

var Direction;

(function (Direction) {
  Direction["x"] = "x";
  Direction["y"] = "y";
  Direction["z"] = "z";
})(Direction || (Direction = {}));

function debounce(func, timeout) {
  var _this = this;

  if (timeout === void 0) {
    timeout = 300;
  }

  var timer;
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, timeout);
  };
}
function isIntegar(obj) {
  return typeof obj === 'number' && obj % 1 === 0;
}
function checkCanUse(yoda, namespace, name) {
  return __awaiter(this, void 0, void 0, function () {
    var canUseRes;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , yoda.tool.canIUse({
            namespace: namespace,
            name: name
          })];

        case 1:
          canUseRes = _a.sent();
          return [2
          /*return*/
          , canUseRes.result === 1 && canUseRes.canUse];
      }
    });
  });
}
function parsePlatform(userAgent) {
  if (userAgent === void 0) {
    userAgent = '';
  }

  if (userAgent.includes('Android') || userAgent.includes('Adr')) {
    return 'android';
  }

  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    return 'ios';
  }

  return 'else';
}
function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

var SHAKE_EVENT = 'native_yoda_shaked';
var SHAKE_START_EVENT = 'native_yoda_shake_start';
var SHAKE_END_EVENT = 'native_yoda_shake_end';
var JUDGE_STOP_TIME = 1000;
var DEFAULT_SETTING = {
  level: 2,
  times: 3,
  intervalTime: 1300,
  iOSIntervalTime: 500,
  androidIntervalTime: 1300,
  isEmitImmediately: true
};
var ANDROID_LEVEL_MAP = {
  1: {
    basic: 13,
    total: 450
  },
  2: {
    basic: 16,
    total: 700
  },
  3: {
    basic: 20,
    total: 1100
  }
};
var IOS_LEVEL_MAP = {
  1: {
    basic: 9,
    total: 220
  },
  2: {
    basic: 12,
    total: 400
  },
  3: {
    basic: 14,
    total: 500
  }
};

var ShakeHandler =
/** @class */
function () {
  function ShakeHandler(props) {
    var _this = this;

    this.shakeConfig = {};
    this.shakedArr = [];
    this.isChecking = false;
    this.nowStatus = {
      x: 0,
      y: 0,
      z: 0
    };
    this.lastStatus = {
      x: 0,
      y: 0,
      z: 0
    };
    this.checkIsShakeStoped = false;
    this.notEmitButShaked = true;
    this.isShakeStarted = false;
    this.isAndroid = false;
    this.isArrivedConfigStandard = false;
    this.levelMap = ANDROID_LEVEL_MAP;
    this.dispatchEvent = null;
    this.setStillShaking = debounce(function () {
      return _this.notShaking();
    }, JUDGE_STOP_TIME);
    this.dispatchEvent = props.dispatchEvent;
    this.isAndroid = props.isAndroid;
    this.levelMap = this.isAndroid ? ANDROID_LEVEL_MAP : IOS_LEVEL_MAP;
  }

  ShakeHandler.prototype.setOptions = function (options) {
    if (options) {
      this.shakeConfig = __assign(__assign({}, DEFAULT_SETTING), options); // iOS 和 Android重力感应的灵敏度等都不太一样，数值分端调试，并在次数上允许小量误差

      this.shakeConfig.times = this.isAndroid ? this.shakeConfig.times - 1 : (this.shakeConfig.times - 1) * 2;
      this.shakeConfig.intervalTime = this.isAndroid ? this.shakeConfig.androidIntervalTime : this.shakeConfig.iOSIntervalTime;
    } else {
      this.shakeConfig = __assign({}, DEFAULT_SETTING);
    }
  };

  ShakeHandler.prototype.resetShakeStatus = function (isStoped) {
    this.shakedArr = [];
    this.isChecking = false;
    this.notEmitButShaked = false;

    if (isStoped) {
      this.isArrivedConfigStandard = false;
      this.isShakeStarted = false;
    }
  };

  ShakeHandler.prototype.checkIsShake = function (result) {
    var _this = this;

    this.isChecking = true;
    Object.keys(this.nowStatus).forEach(function (key) {
      return _this.nowStatus[key] = result[key] * 9.8;
    });

    if (this.judgeArrivedTerminal()) {
      this.lastStatus = {
        x: 0,
        y: 0,
        z: 0
      };
      this.handleShakeHappend();
      this.setStillShaking();
      this.isChecking = false;
      return;
    }

    if (this.judgeLikelyShake()) {
      this.handleArrivedStandard();
    } else {
      this.isChecking = false;
    }
  };

  ShakeHandler.prototype.judgeLikelyShake = function () {
    var _a = this.nowStatus,
        x = _a.x,
        y = _a.y,
        z = _a.z;
    var _b = this.levelMap[this.shakeConfig.level],
        basic = _b.basic,
        total = _b.total;
    return x > basic || y > basic || z > basic || x * x + y * y + z * z > total;
  }; // 用加速度变化最大的方向作为判断依据，确认加速度是否反向，从而判定是否到达一次摇动的端点


  ShakeHandler.prototype.judgeArrivedTerminal = function () {
    var _this = this;

    var maxDiffVal = 0;
    var diffVal = 0;
    var toJudgeKey = Direction.x; // 获取加速度变化最大的方向

    Object.keys(this.nowStatus).forEach(function (key) {
      diffVal = Math.abs(_this.lastStatus[key] - _this.nowStatus[key]);

      if (maxDiffVal < diffVal) {
        toJudgeKey = key;
        maxDiffVal = diffVal;
      }
    });

    if (this.lastStatus[toJudgeKey] * this.nowStatus[toJudgeKey] < 0) {
      return true;
    }

    return false;
  };

  ShakeHandler.prototype.handleArrivedStandard = function () {
    this.lastStatus = __assign({}, this.nowStatus);
    this.checkIsShakeStoped = false;
    this.setStillShaking();
  };

  ShakeHandler.prototype.handleShakeHappend = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.isShakeStarted) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.dispatchEvent({
              type: SHAKE_START_EVENT,
              data: {}
            })];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            this.isShakeStarted = true;
            console.log('!!!handleShakeHappend!!!!!!!!!!!!!!!');
            this.updateShakedArr(new Date().getTime());
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ShakeHandler.prototype.notShaking = function () {
    console.log('notShaking!!!!!');
    this.checkIsShakeStoped = true;
    this.checkDoDelayEmit();
  };

  ShakeHandler.prototype.updateShakedArr = function (newTimeStamp) {
    var intervalTime = this.shakeConfig.intervalTime;

    if (this.shakedArr.length > 0) {
      if (newTimeStamp - this.shakedArr[this.shakedArr.length - 1] <= intervalTime) {
        this.shakedArr.push(newTimeStamp);
      } else {
        this.shakedArr = [];
        this.isChecking = false;
      }
    } else {
      this.shakedArr.push(newTimeStamp);
    }

    console.log(this.shakedArr.length, this.shakeConfig.times); // 允许少许误差

    if (this.shakedArr.length >= this.shakeConfig.times) {
      this.handleArrivedEmitStandard();
    } else {
      this.isChecking = false;
    }
  };

  ShakeHandler.prototype.handleArrivedEmitStandard = function () {
    this.isArrivedConfigStandard = true;
    this.resetShakeStatus();

    if (this.shakeConfig.isEmitImmediately) {
      this.dispatchEvent({
        type: SHAKE_EVENT,
        data: {}
      });
    } else {
      this.notEmitButShaked = true;
    }
  };

  ShakeHandler.prototype.checkDoDelayEmit = function () {
    if (this.notEmitButShaked && this.checkIsShakeStoped && !this.shakeConfig.isEmitImmediately) {
      this.dispatchEvent({
        type: SHAKE_EVENT,
        data: {}
      });
    }

    if (this.isShakeStarted) {
      this.dispatchEvent({
        type: SHAKE_END_EVENT,
        data: {
          isArrivedConfigStandard: this.isArrivedConfigStandard
        }
      });
    }

    this.resetShakeStatus(true);
  };

  return ShakeHandler;
}();

var interval = 60;
var shakeHandler = null;
var checkIsShake = null;

function startMonitorShake(yoda) {
  return __awaiter(this, void 0, void 0, function () {
    var startAccelerometerRes, eventRes;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , yoda.system.startAccelerometer({
            interval: interval
          })];

        case 1:
          startAccelerometerRes = _a.sent();
          checkIsShake = shakeHandler.checkIsShake.bind(shakeHandler);
          return [4
          /*yield*/
          , yoda.event.addEventListener('accelerometer-change', checkIsShake)];

        case 2:
          eventRes = _a.sent();

          if (startAccelerometerRes.result === 1 && eventRes.result !== 1) {
            stopMonitorShake(yoda);
          }

          if (startAccelerometerRes.result !== 1 || eventRes.result !== 1) {
            throw new Error("\u6447\u4E00\u6447\u521D\u59CB\u5316\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002AccelerometerRes:" + JSON.stringify(startAccelerometerRes) + ";eventRes:" + JSON.stringify(eventRes));
          }

          return [2
          /*return*/
          ];
      }
    });
  });
}

function validateOption(options) {
  if (!options) {
    return;
  }

  var level = options.level,
      times = options.times;
      options.intervalTime;
      var isEmitImmediately = options.isEmitImmediately; // android 和 iOS 级别类型一致

  if (level !== undefined && !ANDROID_LEVEL_MAP[level]) {
    throw new Error('请传入正确的level，可选值为1、2、3');
  }

  if (times !== undefined) {
    if (!isIntegar(times)) {
      throw new Error('times应为整数');
    }

    if (times < 1) {
      throw new Error('times应大于1');
    }
  }

  if (isEmitImmediately !== undefined) {
    if (typeof isEmitImmediately !== 'boolean') {
      throw new Error('isEmitImmediately应为boolean类型');
    }
  }
}

function initShakeHandler(options, yoda) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , checkCanUse(yoda, 'system', 'startAccelerometer')];

        case 1:
          if (!_a.sent()) {
            throw new Error('当前APP暂不支持摇一摇');
          }

          if (shakeHandler) {
            throw new Error('当前存在尚未结束监听的摇一摇');
          }

          shakeHandler = new ShakeHandler({
            dispatchEvent: yoda.event.dispatchEvent,
            isAndroid: parsePlatform(navigator.userAgent) === 'android'
          });
          validateOption(options);
          shakeHandler.setOptions(options);
          shakeHandler.resetShakeStatus();
          return [4
          /*yield*/
          , startMonitorShake(yoda)];

        case 2:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  });
}
function stopMonitorShake(yoda) {
  return __awaiter(this, void 0, void 0, function () {
    var eventRes, stopRes;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , checkCanUse(yoda, 'system', 'stopAccelerometer')];

        case 1:
          if (!_a.sent()) {
            throw new Error('当前APP暂不支持摇一摇');
          }

          shakeHandler = null;
          return [4
          /*yield*/
          , yoda.event.removeEventListener('accelerometer-change', checkIsShake)];

        case 2:
          eventRes = _a.sent();
          return [4
          /*yield*/
          , yoda.system.stopAccelerometer()];

        case 3:
          stopRes = _a.sent();

          if (eventRes.result !== 1 || stopRes.result !== 1) {
            throw new Error("\u6447\u4E00\u6447\u505C\u6B62\u76D1\u542C\u5931\u8D25\u3002stopRes:" + JSON.stringify(stopRes) + ";eventRes:" + JSON.stringify(eventRes));
          }

          return [2
          /*return*/
          ];
      }
    });
  });
}

var _a, _b;
var yodaCustomEvent = {
  shaked: SHAKE_EVENT
};
var eventToInitMap = (_a = {}, _a[yodaCustomEvent.shaked] = initShakeHandler, _a);
var handleEventUnregisterMap = (_b = {}, _b[yodaCustomEvent.shaked] = stopMonitorShake, _b);

function createEventCenter(yoda) {
  function addEventListenerHandler(eventInfo, listener, callback) {
    var _a;

    return __awaiter(this, void 0, void 0, function () {
      var type, options, err_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            type = typeof eventInfo === 'string' ? eventInfo : eventInfo.type;
            options = typeof eventInfo === 'string' ? {} : eventInfo.options;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , (_a = eventToInitMap[type]) === null || _a === void 0 ? void 0 : _a.call(eventToInitMap, options, yoda)];

          case 2:
            _b.sent();

            return [3
            /*break*/
            , 4];

          case 3:
            err_1 = _b.sent();
            return [2
            /*return*/
            , {
              result: -1,
              message: err_1.message
            }];

          case 4:
            return [2
            /*return*/
            , addEventListener(type, listener, callback)];
        }
      });
    });
  }

  function addEventListener(type, listener, callback) {
    listener.__yodaCallbackId__ = listener.__yodaCallbackId__ || {}; // 支持同一个 listener 绑定多个事件；不支持同一个事件同一个 listener 多次绑定

    if (listener.__yodaCallbackId__[type]) {
      throw new Error("addEventListener " + type + " \u7684 listener \u5DF2\u7ECF\u88AB\u7ED1\u5B9A\u8FC7\u4E86");
    }

    var callbackId = yoda.genCallbackId();
    yoda._callbacks[callbackId] = listener;
    var eventSet = yoda._eventListeners[type];

    if (!eventSet) {
      eventSet = yoda._eventListeners[type] = {};
    }

    eventSet[callbackId] = true;
    listener.__yodaCallbackId__[type] = callbackId;
    return yoda.event._addEventListener({
      type: type,
      listener: callbackId
    }, callback);
  }

  function isEmpty(value) {
    for (var key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        return false;
      }
    }

    return true;
  }

  function removeEventCallbacks(type, listener, listenerId) {
    if (listener.__yodaCallbackId__) {
      delete listener.__yodaCallbackId__[type]; // 只有当所有事件都被解绑，listener 才能被 delete

      if (isEmpty(listener.__yodaCallbackId__)) {
        delete listener.__yodaCallbackId__;
        delete yoda._callbacks[listenerId];
      }
    }
  } // 不传 listener 时，需要移除该 type 下的所有 listener


  function removeEventListener(type, listener, callback) {
    var _a;

    return __awaiter(this, void 0, void 0, function () {
      var listenerId, eventSet, err_2, resPromise, promise;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            eventSet = yoda._eventListeners[type];
            if (!listener) return [3
            /*break*/
            , 5];
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , (_a = handleEventUnregisterMap[type]) === null || _a === void 0 ? void 0 : _a.call(handleEventUnregisterMap, yoda)];

          case 2:
            _b.sent();

            return [3
            /*break*/
            , 4];

          case 3:
            err_2 = _b.sent();
            return [2
            /*return*/
            , {
              result: -1,
              message: err_2.message
            }];

          case 4:
            listenerId = listener.__yodaCallbackId__ && listener.__yodaCallbackId__[type];

            if (!(listenerId && eventSet && eventSet[listenerId])) {
              resPromise = Promise.resolve({
                result: 1
              });
              callback && resPromise.then(callback);
              return [2
              /*return*/
              , resPromise];
            }

            _b.label = 5;

          case 5:
            promise = yoda.event._removeEventListener({
              type: type,
              listener: listenerId
            }, callback); // bridge 成功时清除回调

            promise.then(function (ret) {
              // 约定 客户端没有找到对应的 listenerId 也返回 result: 1
              // 约定 result 不为1的时候不删
              if (ret.result === 1) {
                if (listener) {
                  delete eventSet[listenerId];
                  removeEventCallbacks.call(yoda, type, listener, listenerId);
                } else {
                  // 不传 listener 时，需要移除该 type 下的所有 listener
                  if (eventSet) {
                    delete yoda._eventListeners[type];

                    for (var key in eventSet) {
                      removeEventCallbacks.call(yoda, type, yoda._callbacks[key], key);
                    }
                  }
                }
              }
            });
            return [2
            /*return*/
            , promise];
        }
      });
    });
  }

  return {
    addEventListenerHandler: addEventListenerHandler,
    removeEventListener: removeEventListener
  };
}

function initEvent$1(yoda) {
  var eventNamespace = yoda.event;
  var eventCenter = createEventCenter(yoda);

  if (eventNamespace && eventNamespace.addEventListener) {
    eventNamespace._addEventListener = eventNamespace.addEventListener;
    eventNamespace.addEventListener = eventCenter.addEventListenerHandler;
  }

  if (eventNamespace && eventNamespace.removeEventListener) {
    eventNamespace._removeEventListener = eventNamespace.removeEventListener;
    eventNamespace.removeEventListener = eventCenter.removeEventListener;
  }
}

var ua = navigator.userAgent;
var cookie = document.cookie;

function getUAInfo(key) {
  var uaList = {};
  ua.split(' ').forEach(function (item) {
    var arr = item.split('/');
    uaList[arr[0]] = arr[1];
  });
  return uaList[key] ? uaList[key] : uaList;
}

function getWebViewType() {
  if (ua.indexOf('Android') !== -1) {
    return 'WebView';
  }

  if (ua.indexOf('iPhone') !== -1) {
    var uaList = getUAInfo();

    if (uaList.Yoda && uaList.WebViewType === 'WK') {
      return 'YodaWKWebView';
    }

    if (!uaList.Yoda && uaList.WebView === 'WKWebView') {
      return 'WKWebView';
    }

    return 'UIWebView';
  }

  return '';
}

function getCookie(name) {
  var match = cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : '';
}

function sendEventLog(radarProjectId, data, startTime) {
  if (data === void 0) {
    data = {};
  }

  if (startTime === void 0) {
    startTime = 0;
  }

  var yoda = this;
  var duration = new Date().getTime() - startTime;
  yoda.ready(function () {
    yoda.tool.sendRadarLog && yoda.tool.sendRadarLog({
      removeStashedLog: [],
      sendImmediate: true,
      customData: {
        project_id: radarProjectId || "yoda_kpn_" + getCookie('kpn'),
        url_package: {
          page_type: 2,
          page: location.href,
          params: '',
          identity: getCookie('did')
        },
        data: [{
          key: 'event',
          value: {
            duration: startTime && duration
          },
          dimension: __assign({
            yoda_version: getUAInfo('Yoda') || '',
            webview_type: getWebViewType()
          }, data)
        }]
      }
    });
  });
}

/**
 * 创建 api 列表
 */

function createFeApiMap(apiCreatorMap, yoda) {
  return __awaiter(this, void 0, void 0, function () {
    var onCreateError, apiList, result;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          onCreateError = function onCreateError(apiKey, error) {
            return console.error("[yoda] create fe api: " + apiKey + " failed, ", error);
          };

          apiList = Object.keys(apiCreatorMap);
          return [4
          /*yield*/
          , Promise.all(apiList.reduce(function (apiResult, apiKey) {
            try {
              var api = apiCreatorMap[apiKey](yoda);

              if (isPromise(api)) {
                api.catch(function (e) {
                  onCreateError(apiKey, e);
                  return null;
                });
              }

              return __spreadArray(__spreadArray([], apiResult), [api]);
            } catch (e) {
              onCreateError(apiKey, e);
            }

            return apiResult;
          }, []))];

        case 1:
          result = _a.sent();
          return [2
          /*return*/
          , result.reduce(function (apiObj, apiResult, index) {
            var _a;

            if (!apiResult) {
              return apiObj;
            }

            return __assign(__assign({}, apiObj), (_a = {}, _a[apiList[index]] = apiResult, _a));
          }, {})];
      }
    });
  });
}

var FeApiCommonResultCode = {
  notSupport: -1000,
  argsError: 125007
};

var createArgsError = function createArgsError(message) {
  return {
    result: FeApiCommonResultCode.argsError,
    message: message
  };
};

var MaxDuration = 600000;
var SupportedFormat = ['m4a'];
var RecorderMsg = {
  startConfigEmpty: 'start 方法需要传入 config 参数',
  startDurationEmpty: 'duration 应该为大于等于 0 的整数',
  startDurationLimit: "duration \u4E0D\u80FD\u8D85\u8FC7\u6700\u5927\u503C " + MaxDuration + "\uFF0810\u5206\u949F\uFF09",
  startFormat: "format \u53EA\u652F\u6301: " + SupportedFormat.join(';')
};

function canUseRecorder(yoda) {
  return !!yoda.event && !!yoda.system && !!yoda.system.startAudioRecorder && !!yoda.system.stopAudioRecorder;
}
/**
 * 每次 start 都需要给客户端传一个 taskId
 * 后续事件会携带这个 taskId
 * @returns
 */


function genTaskId() {
  return "" + Date.now();
}
/** start bridge 参数校验 */


function getStartConfigError(config) {
  if (!config) {
    return createArgsError(RecorderMsg.startConfigEmpty);
  }

  if (!Number.isInteger(config.duration) || config.duration <= 0) {
    return createArgsError(RecorderMsg.startDurationEmpty);
  }

  if (config.duration > MaxDuration) {
    return createArgsError(RecorderMsg.startDurationLimit);
  }

  if (!config.format || !SupportedFormat.includes(config.format)) {
    return createArgsError(RecorderMsg.startFormat);
  }

  return null;
}
/**
 * 监听客户端事件
 * 每个事件全局只监听一次，在前端 dispatch
 * @param yoda
 * @returns
 */


function initEvent(yoda) {
  var listened = false; // 各个事件的 listener

  var ListenerMap = {
    start: [],
    stop: [],
    error: []
  }; // 当前需要处理的 event id (只触发了 start 但没有 stop / error)

  var EventIdMap = new Map(); // 延迟监听客户端事件

  var listenNativeEvent = function listenNativeEvent() {
    if (listened) {
      return;
    }

    listened = true;
    yoda.event.addEventListener('native_audio_recorder_start', dispatchEvent('start'));
    yoda.event.addEventListener('native_audio_recorder_stop', dispatchEvent('stop'));
    yoda.event.addEventListener('native_audio_recorder_error', dispatchEvent('error'));
  };

  var addEventListener = function addEventListener(type) {
    return function (cb) {
      listenNativeEvent();
      ListenerMap[type].push(cb);
      return function () {
        return ListenerMap[type] = ListenerMap[type].filter(function (item) {
          return item !== cb;
        });
      };
    };
  };

  var dispatchEvent = function dispatchEvent(type) {
    return function (e) {
      // 过滤非自己主动 start 的事件
      if (!EventIdMap.has(e.taskId)) {
        return;
      } // 录音结束，不再监听对应的事件


      if (type === 'stop' || type === 'error') {
        EventIdMap.delete(e.taskId);
      }

      ListenerMap[type].forEach(function (item) {
        return !!e ? item(e) : item();
      });
    };
  };

  return {
    onStart: addEventListener('start'),
    onStop: addEventListener('stop'),
    onError: addEventListener('error'),
    addListenId: function addListenId(id) {
      return EventIdMap.set(id, true);
    },
    rmListenId: function rmListenId(id) {
      return EventIdMap.delete(id);
    }
  };
}

var createRecorderManager = function createRecorderManager(yoda) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a, onStart, onStop, onError, addListenId, rmListenId, start, stop;

    return __generator(this, function (_b) {
      if (!canUseRecorder(yoda)) {
        return [2
        /*return*/
        , null];
      }

      _a = initEvent(yoda), onStart = _a.onStart, onStop = _a.onStop, onError = _a.onError, addListenId = _a.addListenId, rmListenId = _a.rmListenId;

      start = function start(config) {
        return __awaiter(void 0, void 0, void 0, function () {
          var configError, taskId, res;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                configError = getStartConfigError(config);

                if (configError) {
                  return [2
                  /*return*/
                  , configError];
                }

                taskId = genTaskId();
                addListenId(taskId);
                return [4
                /*yield*/
                , yoda.system.startAudioRecorder(__assign(__assign({}, config), {
                  taskId: taskId
                })) // 创建失败，删除 id 
                ];

              case 1:
                res = _a.sent(); // 创建失败，删除 id 

                if (!res || res.result !== 1) {
                  rmListenId(taskId);
                }

                return [2
                /*return*/
                , res];
            }
          });
        });
      };

      stop = function stop() {
        return yoda.system.stopAudioRecorder();
      };

      return [2
      /*return*/
      , {
        start: start,
        stop: stop,
        onStart: onStart,
        onStop: onStop,
        onError: onError
      }];
    });
  });
};

var FileManagerMsg = {
  readFileConfigMiss: 'readFile 方法需要传入 config 参数',
  filePathEmpty: 'filePath 参数不能为空',
  encodingEmpty: 'encoding 参数不能为空'
};

function canUseFileManager(yoda) {
  return !!yoda.system && !!yoda.system.readFile;
}

function getReadFileConfigError(config) {
  if (!config) {
    return createArgsError(FileManagerMsg.readFileConfigMiss);
  }

  if (!config.filePath) {
    return createArgsError(FileManagerMsg.filePathEmpty);
  }

  if (!config.encoding) {
    return createArgsError(FileManagerMsg.encodingEmpty);
  }

  return null;
}

var createFileManager = function createFileManager(yoda) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (!canUseFileManager(yoda)) {
        return [2
        /*return*/
        , null];
      }

      return [2
      /*return*/
      , {
        readFile: function readFile(config) {
          var configError = getReadFileConfigError(config);

          if (configError) {
            return configError;
          }

          return yoda.system.readFile(config);
        }
      }];
    });
  });
};

var FEApiMap = {
  // 录音
  recorderManager: createRecorderManager,
  // 文件
  fileManager: createFileManager
};

var YodaFeApiKey = 'feApi';
/**
 * yoda-kuaishou-plugin 里会做大小写转换
 * 客户端只认大写的
 */

var NAMESPACE_2_GLOBALVAR = {
  kwai: 'Kwai',
  kwaiAd: 'KwaiAd',
  kwaiAdThird: 'KwaiAdThird',
  kwaiMerchant: 'KwaiMerchant',
  kwaiLive: 'KwaiLive',
  // 以防使用大写 namespace 进行调用，大写的映射关系也加上
  Kwai: 'Kwai',
  KwaiAd: 'KwaiAd',
  KwaiAdThird: 'KwaiAdThird',
  KwaiMerchant: 'KwaiMerchant',
  KwaiLive: 'KwaiLive'
};

function initFEApi(yoda) {
  return __awaiter(this, void 0, void 0, function () {
    var apiMap;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , createFeApiMap(FEApiMap, yoda)];

        case 1:
          apiMap = _a.sent();
          yoda[YodaFeApiKey] = apiMap;
          return [2
          /*return*/
          ];
      }
    });
  });
}

function init() {
  var _this = this;

  var yoda = this;

  var already = function already() {
    var startTime = Date.now();
    yoda.register({
      namespace: 'tool',
      name: 'getApiList'
    });
    yoda.tool.getApiList({}, function (_a) {
      var result = _a.result,
          apiList = _a.apiList;
      return __awaiter(_this, void 0, void 0, function () {
        var l, api, overWriteApi;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              // 方法不存在时使用兜底api
              if (result !== 1) {
                apiList = baseApis;
              }

              for (l = apiList.length; l--;) {
                api = apiList[l];
                overWriteApi = overWriteApis[api.namespace + '.' + api.name];

                if (overWriteApi) {
                  api = __assign(__assign({}, api), overWriteApi);
                }

                if (result === 1) {
                  this._apisMap = {
                    result: result,
                    apiList: apiList
                  };
                }

                yoda.register(__assign({}, api));
              } // 初始化事件


              initEvent$1(yoda); // 初始化前端自定义 api

              return [4
              /*yield*/
              , initFEApi(yoda) // https://radar.corp.kuaishou.com/project/2fa790a375/dashboard
              // 记录通过 getApiList 获取桥列表自动 register 时间
              ];

            case 1:
              // 初始化前端自定义 api
              _b.sent(); // https://radar.corp.kuaishou.com/project/2fa790a375/dashboard
              // 记录通过 getApiList 获取桥列表自动 register 时间


              sendEventLog.call(yoda, '2fa790a375', {
                name: 'yoda_auto_register',
                category: 'yoda_js_sdk',
                result_type: result,
                extra_info: JSON.stringify({
                  res: this._apisMap,
                  apiLength: apiList.length
                })
              }, startTime); // 触发 yoda.ready

              yoda._readyResolve();

              return [2
              /*return*/
              ];
          }
        });
      });
    });
  }; // 对已经注入bridge的 直接ready


  if (window.__yodaBridge__) {
    already();
  } else {
    window.__yodaBridgeReady__ = already;
  }
}

function callbackHandler (_a) {
  var id = _a.id,
      params = _a.params;
  var callback = this._callbacks[id];

  if (callback) {
    callback(params);
  } // TODO result 不为1 上报

}

// 准备aop插件系统
function setupPlugin(yoda, config) {
  yoda._plugins = [];

  var _loop_1 = function _loop_1(name_1) {
    var realFn = config[name_1];
    var surfix = name_1[0].toUpperCase() + name_1.slice(1);
    var beforeName = 'before' + surfix;
    var afterName = 'after' + surfix;

    yoda[name_1] = function (params) {
      var plugins = yoda._plugins;
      var length = plugins.length;
      var index = -1;

      var next = function next() {
        var _loop_2 = function _loop_2() {
          var fn = plugins[index][beforeName];

          if (typeof fn === 'function') {
            var called_1 = false;
            fn.call(yoda, params, function () {
              if (!called_1) {
                called_1 = true;
                next();
              }
            });
            return {
              value: void 0
            };
          }
        };

        while (++index < length) {
          var state_1 = _loop_2();

          if (typeof state_1 === "object") return state_1.value;
        }

        realFn.call(yoda, params);

        for (var i = 0; i < length; i++) {
          var fn = plugins[i][afterName];

          if (typeof fn === 'function') {
            fn.call(yoda, params);
          }
        }
      };

      next();
    };
  };

  for (var name_1 in config) {
    _loop_1(name_1);
  }

  return function plugin(config) {
    // config 可以是 class 或者 对象
    if (typeof config === 'function') {
      config = new config(yoda);
    }

    yoda._plugins.push(config);
  };
}

function beforeInvoke$1(invokeConfig, next) {
  var namespace = invokeConfig.namespace,
      name = invokeConfig.name,
      params = invokeConfig.params,
      callbackId = invokeConfig.callbackId; // 缓存 getApiList 结果，避免多次调用桥获取

  if (namespace === 'tool' && Object.keys(this._apisMap).length !== 0) {
    if (name === 'getApiList') {
      window.__yodaBridgeCallback__(callbackId, this._apisMap);

      return;
    }

    if (name === 'canIUse') {
      var apiList = this._apisMap.apiList;
      var namespace_1 = params.namespace,
          name_1 = params.name;
      var realNamespace_1 = NAMESPACE_2_GLOBALVAR[namespace_1] || namespace_1;
      var canUse = apiList.some(function (api) {
        var ns = api.namespace;
        var bridgeName = api.name;
        return ns === realNamespace_1 && bridgeName === name_1;
      });

      window.__yodaBridgeCallback__(callbackId, {
        result: 1,
        canUse: canUse
      });

      return;
    }
  }

  next();
}

var CacheApiListPlugin = {
  beforeInvoke: beforeInvoke$1
};

var USER_AGENT = window && window.navigator && window.navigator.userAgent.toLowerCase() || '';
var isIOS = /(iPhone|iPad|iPod|iOS)/i.test(USER_AGENT);

var BridgeMethodMap = {
  requestLocationPermission: 'requestLocationPermissionWithPermissionCheck',
  getLocation: 'getLocationWithPermissionCheck',
  syncLocation: 'syncLocationWithPermissionCheck'
};

function isLocationBridge(namespace, name) {
  return namespace.toLocaleLowerCase() === 'kwai' && !!BridgeMethodMap[name];
}

function hasLocationPermissionBridge(yoda, name) {
  var bridgeName = BridgeMethodMap[name];
  return yoda.kwai && !!yoda.kwai[bridgeName] || yoda.Kwai && yoda.Kwai[bridgeName];
}
/**
 * 有新 bridge 时，调用新 bridge，没有走之前逻辑
 */


function beforeInvoke(config, next) {
  var yoda = this;
  var namespace = config.namespace,
      name = config.name,
      params = config.params,
      callbackId = config.callbackId; // 其他的 bridge

  if (!isLocationBridge(namespace, name)) {
    return next();
  } // 没有新的 bridge 


  if (!hasLocationPermissionBridge(yoda, name)) {
    // iOS 上旧版本只能用这个
    if (isIOS && name === 'requestLocationPermission') {
      config.name = 'requestLocationAuthorization';
    }

    return next();
  } // 调用新的 bridge 


  config.name = BridgeMethodMap[name];
  config.params = __assign(__assign({}, params), {
    forced_permission_request: params.forced_permission_request || 2
  }); // ks-bridge

  if (config.params.callback) {
    // @ts-ignore
    var callback_1 = window[config.params.callback]; // @ts-ignore

    window[config.params.callback] = function (data) {
      var parseError = false;

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.warn(e); // eslint-disable-line

          parseError = true;
        }
      }

      callback_1(parseError ? data : __assign(__assign({}, data), {
        withPermissionCheck: true
      }));
    };
  } else {
    // yoda 
    var oldCallback_1 = yoda._callbacks[callbackId];

    yoda._callbacks[callbackId] = function (res) {
      res.withPermissionCheck = true;
      oldCallback_1(res);
    };
  }

  next();
}

var LocationPermissionPlugin = {
  beforeInvoke: beforeInvoke
};

var version = "0.5.0-beta.3";

// 与客户端约定的接口描述
var SafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;

var Yoda =
/** @class */
function () {
  function Yoda() {
    this.isInYoda = !!window.__yodaBridge__;
    this._instanceId = this.genInstanceId();
    this._callbackId = 1;
    this._callbacks = {};
    this._eventListeners = {};
    this._apisMap = {};
    this._readyPromise = _readyPromise;
    this._readyResolve = _readyResolve;
    this.ready = ready;
    this._plugins = [];
    this.version = version;
    this.overflow = false; // 准备插件系统

    this.plugin = setupPlugin(this, {
      register: register,
      invoke: invoke,
      callbackHandler: callbackHandler,
      init: init
    });
  }

  Yoda.prototype.genCallbackId = function () {
    var id = this.genNextId(); // 如果生成的 id 溢出了，从头开始
    // 页面中应该不会有这么多的回调

    if (id >= SafeInteger) {
      this.overflow = true;
      this._callbackId = 1; // 重新生成 insId 尽量减少重复的概率

      this._instanceId = this.genInstanceId();
      return this.genCallbackId();
    }

    return "" + id;
  };

  Yoda.prototype.genNextId = function () {
    var callbackId = this._instanceId + this._callbackId++; // 溢出后需要判断是否已经存在对应的 id 

    while (this.overflow && this._callbacks[callbackId]) {
      callbackId = this._instanceId + this._callbackId++;
    }

    return callbackId;
  };
  /**
   * ios 客户端目前会将 callbackId 处理为 number
   * 需要尽可能的保证生成的 _instanceId 与其他页面不会重复 & 不会超出 Number.MAX_SAFE_INTEGER
   * 3位随机数 + 9位时间戳 + 4位自增 id
   */


  Yoda.prototype.genInstanceId = function () {
    var safeIntegerStr = "" + SafeInteger; // 取 3 位随机数避免同一时刻出现重复 & 避免数字溢出

    var maxRandom = Number(safeIntegerStr.slice(0, 3)) - 100;
    var random = Math.floor(Math.random() * maxRandom); // 取 9 位时间戳，保证1周内不会重复

    var date = "" + Date.now();
    var dateStr = date.slice(date.length - 9); // 剩下的都作为自增 id 

    var zero = new Array(safeIntegerStr.length - 12).fill(0).join('');
    return Number("" + random + dateStr + zero);
  };

  return Yoda;
}();

var yoda = new Yoda(); // 用于接收客户端回调

window.__yodaBridgeCallback__ = function (id, params) {
  yoda.callbackHandler({
    id: id,
    params: params
  });
};

[CacheApiListPlugin, LocationPermissionPlugin // 地理位置权限
].forEach(function (pluginItem) {
  return yoda.plugin(pluginItem);
}); // 下一个 event loop 再初始化, 为了可以改写 init 方法

setTimeout(function () {
  return yoda.init();
});

export default yoda;
